function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import httpAdapter from 'axios/lib/adapters/http';
import axios from 'axios';
import { HttpHeaders } from "../constants";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { selectors } from "./state-selectors";
import { ErrorResponse } from "../infra/ErrorResponse";
export let APIHost = /*#__PURE__*/function (APIHost) {
  APIHost["KYB"] = "kyb";
  APIHost["Plaid"] = "plaid";
  APIHost["Scout"] = "scout";
  return APIHost;
}({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export function initSendRequest(_ref) {
  let {
    slackClient: {
      sendRoleIntentLoggerMessage
    },
    getState,
    getCookie,
    onCookieChange,
    onLogout,
    onReportToSentry
  } = _ref;
  return function sendRequest(options) {
    const {
      method = 'post',
      params = {},
      data = {},
      apiHost,
      useMgmtHost,
      disableAuth,
      forceAuthorizationHeader,
      authToken,
      url,
      disableSentry,
      urlForSentry,
      config,
      allowedForAccountants
    } = options;
    const {
      mgmtHost,
      apiHost: apiHostname,
      apiGatewayHost,
      useAuthorizationHeader
    } = getState().session;
    const actualHost = useMgmtHost ? mgmtHost : apiHost != null && [APIHost.Plaid, APIHost.Scout, APIHost.KYB].includes(apiHost) ? apiGatewayHost : apiHostname;
    const fullUrl = actualHost + url;
    const prevCookie = getCookie();
    const axiosConfig = _objectSpread(_objectSpread({}, config), {}, {
      adapter: httpAdapter,
      withCredentials: true,
      params
    });
    if (!axiosConfig.headers) {
      axiosConfig.headers = {};
    }
    if (!axiosConfig.headers[HttpHeaders.ContentType]) {
      axiosConfig.headers[HttpHeaders.ContentType] = 'application/json';
    }
    if (apiHost != null) {
      axiosConfig.headers = _objectSpread(_objectSpread({}, axiosConfig.headers), {}, {
        ['x-api-host']: apiHost
      });
    }
    const actualAuthToken = (disableAuth || !useAuthorizationHeader) && !forceAuthorizationHeader ? null : authToken !== null && authToken !== void 0 ? authToken : getState().authToken;
    if (actualAuthToken) {
      axiosConfig.headers.Authorization = "Bearer ".concat(actualAuthToken);
    }
    if (window._sessionId) {
      axiosConfig.headers[HttpHeaders.SessionId] = window._sessionId;
    }
    const requestId = generateUniqueId('request');
    axiosConfig.headers[HttpHeaders.RequestId] = requestId;
    const isGetRequest = method === 'get';
    if (!isGetRequest && selectors.user.isAccountant(getState()) && !allowedForAccountants) {
      const userId = selectors.user.id(getState());
      const businessId = selectors.user.businessId(getState());
      const text = "An accountant sent a request to ".concat(urlForSentry || url, " (userId=").concat(userId, "; businessId=").concat(businessId, "; location=").concat(location.href, ")");
      sendRoleIntentLoggerMessage(text);
    }
    const request = isGetRequest ? axios.get(fullUrl, axiosConfig) : axios.post(fullUrl, data, axiosConfig);
    return request.then(response => {
      if (prevCookie !== getCookie()) {
        onCookieChange();
      }
      return response;
    }).catch(err => {
      const e = new ErrorResponse(err);
      const is401 = e.status === 401;
      const is403ForReviewer = e.status === 403 && selectors.user.isReviewer(getState());
      const isImpersonating = !!selectors.impersonatingAs(getState());
      if (is401 || is403ForReviewer) {
        onLogout();
      }
      const disableSentryReporting = isImpersonating || disableSentry === 'all' || is401 || is403ForReviewer || Array.isArray(disableSentry) && e.status && disableSentry.includes(e.status) || typeof disableSentry === 'function' && disableSentry(e);
      if (!disableSentryReporting && e.status) {
        onReportToSentry({
          message: "Request (".concat(method.toUpperCase(), " ").concat(urlForSentry || fullUrl, ") failed with status code ").concat(e.status),
          requestId,
          method,
          url: fullUrl,
          responseBody: e.body ? JSON.stringify(e.body) : ''
        });
      }
      throw err;
    });
  };
}